import rules from "../../utils/rules";
import apiService from "../../api/api.service";
import userlist from "../UsersList";
import ImageInput from "@/views/ImageInput";
import telematicsService from "../../api/telematics.service";
import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import smsService from "../../api/reservePlan.service";
import EventBus from "../../utils/EventBus";
export default {
  name: "view-customer-details",
  components: { ImageInput, userlist, pageheader },

  props: [],
  data() {
    return {
      input: {},
      loading: false,
      businessAvatar: {
        imageURL: null,
      },
      infoDialog: false,
      businessResult: [],
      clientLogo: "",
      isBusinessSaved: false,
      isBusinessSaving: false,
      isBusinessUpload: false,
      isBusiness: false,
      clientIdToPass: "",
      valid: true,
      isEditing: false,
      rules: rules,
      customers: {},
      isCustomerLoading: false,
      isUsersLoading: false,
      address: [],
      contactemail: "",
      contactphone: "",

      showSmsLinkOld: false,
      usersList: [],
      smsLinkValid: true,
      smsCustomersList: [],
      selectedSMSCustomer: {},
      isLinkSMSCustomer: false,
      isSMSCustLoad: false,
    };
  },
  computed: {
    ...mapGetters(["roles", "companyIdDropdown"]),
  },
  mounted() {
    this.input = utils.getInputContent("viewcustomerdetails", this.roles);
    this.getCustomer();
    this.getClientLogo();
    this.getSMSCustomersList();
    this.clientIdToPass = this.$route.params.id;
  },
  methods: {
    // BE-1121: access control for a customer is managed in the Access Control
    // section now, and that section is scoped by the toolbar customer selector.
    // So this selects the customer being viewed before navigating -- otherwise
    // the admin lands on Setup pointed at whichever customer the toolbar
    // happened to hold. All four values the toolbar sets are set here, not just
    // the id and name: the SMS linking ids travel with the selection, and
    // leaving them behind would mis-scope the SMS screens.
    goToAccessControlSetup() {
      // Nothing to select until the customer has loaded -- dispatching now would
      // put undefined into the toolbar and both SMS linking ids.
      if (!this.customers || !this.customers.companyName) return;
      const rawId = this.$route.params.id;
      // Prefer the id off the loaded customer: it is the same shape the toolbar
      // stores, and customerAccessCodes is compared against it strictly.
      const customerId =
        this.customers.id != null
          ? this.customers.id
          : isNaN(Number(rawId))
          ? rawId
          : Number(rawId);
      this.$store.dispatch("setCompanyIdDropdown", customerId);
      this.$store.dispatch(
        "setCompanyNameDropdown",
        this.customers.companyName
      );
      this.$store.dispatch(
        "setSMSCustomerLinkingId",
        this.customers.smsCustomerId
      );
      this.$store.dispatch(
        "setSMSBirchLinkingId",
        this.customers.birchCustomerId
      );
      this.$router.push("/access-control/setup");
    },
    async getCustomer() {
      this.isCustomerLoading = true;
      try {
        let response = await telematicsService.getCustomerListById(
          this.$route.params.id,
        );
        if (response) {
          this.isCustomerLoading = false;
          this.customers = response.data;
          this.address = this.customers.addresses[0];
          this.contactemail = this.customers.emails[0].email;
          this.contactphone = this.customers.phones[0].number;
          this.selectedSMSCustomer = {
            CustomerCNUM: this.customers.smsCustomerId,
            BirchCustomerID: this.customers.birchCustomerId,
          };
        } else {
          this.isCustomerLoading = false;
          this.customers = [];
        }
      } catch (err) {
        console.log(err);
        this.isCustomerLoading = false;
      }
    },
    openModal() {
      this.infoDialog = true;
    },
    async getUsers() {
      this.isUsersLoading = true;
      try {
        let response = await apiService.getUsersList(this.$route.params.id);
        if (response) {
          this.isUsersLoading = false;
          this.users = response.data;
        } else {
          this.isUsersLoadingLoading = false;
          this.users = [];
        }
      } catch (err) {
        console.log(err);
        this.isUsersLoading = false;
        this.usersList = [
          {
            userId: "401565c8-12da-4a7a-8a3a-8a272964cc67",
            firstName: "Andrea",
            lastName: "Ruback",
            email: "andrear@birchequipment.com",
            mobileNumber: "555555555",
            cellPhone: "",
            username: "andrear@birchequipment.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: "",
            features: null,
            communityReferenceId: null,
          },
          {
            userId: "15ce9fcc-8f1f-40bf-9564-8b53038cb6fc",
            firstName: "Steve",
            lastName: "Williams",
            email: "bill.mckeen+16@incus5.com",
            mobileNumber: "5555555555",
            cellPhone: "",
            username: "bill.mckeen+16@incus5.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: "",
            features: null,
            communityReferenceId: null,
          },
          {
            userId: "1bc327f7-71b7-4352-8774-197cd15f17e6",
            firstName: "Jessie",
            lastName: "Everson",
            email: "jessicag@birchequipment.com",
            mobileNumber: "555555555",
            cellPhone: "",
            username: "jessicag@birchequipment.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: "",
            features: null,
            communityReferenceId: null,
          },
          {
            userId: "2c33664d-343c-4a79-bb4d-edef7e1c8512",
            firstName: "Jordan",
            lastName: "Mellich",
            email: "jordanm@birchequipment.com",
            mobileNumber: "555555555",
            cellPhone: "",
            username: "jordanm@birchequipment.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: "",
            features: null,
            communityReferenceId: null,
          },
          {
            userId: "fe9e0199-1416-42b7-9c28-7b9a7b74e3ff",
            firstName: " Sarah",
            lastName: "Rothenbuhler",
            email: "SarahD@birchequipment.com",
            mobileNumber: "555555555",
            cellPhone: "",
            username: "SarahD@birchequipment.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: "admin@incus5.com",
            features: null,
            communityReferenceId: null,
          },
          {
            userId: "468ab9f1-5a42-4181-b153-17075dec8e65",
            firstName: "Sarah",
            lastName: "Rothenbuhler",
            email: "zzzzzzzsarahD@birchequipment.com",
            mobileNumber: "3607345744",
            cellPhone: "3607345744",
            username: "zzzzzzzsarahD@birchequipment.com",
            userRole: "Client",
            client: {
              clientId: "fd8ec571-5704-4784-8942-2ff0d80af3ef",
              clientName: "Birch Equipment",
            },
            projectId: null,
            jiraUserId: null,
            features: null,
            communityReferenceId: null,
          },
        ];
      }
    },
    cancelUpdate(isedit) {
      this.isEditing = !isedit;
    },
    async getClientLogo() {
      try {
        let clientLogo = await apiService.getClientLogo(this.$route.params.id);
        if (clientLogo.fileContent) {
          this.clientLogo = clientLogo.fileContent;
        }
      } catch (err) {
        this.clientLogo =
          "data:image/png;base64,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";
      }
    },
    async uploadImage() {
      this.clientLogo = this.businessAvatar.imageString;
      this.isBusinessUpload = true;
      let payload = {
        fileName: this.businessAvatar.fileName,
        fileContent: this.businessAvatar.imageString,
      };
      try {
        let result = await apiService.uploadClientLogo(
          this.$route.params.id,
          this.userId,
          payload,
        );
        if (result.isSuccess) {
          this.$toast.success("Successfully updated client logo");
          this.isBusinessUpload = false;
          this.isBusinessSaved = true;
        }
      } catch (err) {
        this.isBusinessUpload = false;
        this.$toast.error("Unable to update client logo" + err);
      }
    },
    savedAvatar() {
      this.isBusiness = false;
      this.isBusinessSaving = false;
      this.isBusinessSaved = true;
    },
    cancelUpload() {
      if (this.businessResult.image) {
        this.clientLogo = this.businessResult.image;
      }
      setTimeout(() => this.savedAvatar(), 1000);
    },
    updateRouterParams() {
      if (this.$route.query && this.$route.query.isFilter) {
        this.$router.push(
          `/customers?search=${this.$route.query.search}&isFilter=${this.$route.query.isFilter}`,
        );
      } else {
        this.$router.push(`/customers?isFilter=${this.$route.query.isFilter}`);
      }
    },
    async getSMSCustomersList() {
      this.isSMSCustLoad = true;
      try {
        let response = await smsService.getcustomer();
        if (response) {
          this.smsCustomersList = response
            .filter((e) => e.CustomerCNUM != "  0000")
            .sort((a, b) => a.CustomerName.localeCompare(b.CustomerName));
          this.selectedSMSCustomer = {
            CustomerCNUM: this.customers.smsCustomerId,
            BirchCustomerID: this.customers.birchCustomerId,
          };
          this.isSMSCustLoad = false;
        } else {
          this.isSMSCustLoad = false;
          this.smsCustomersList = [];
        }
      } catch (err) {
        this.isSMSCustLoad = false;
        console.log(err);
      }
    },
    clearSMSCustomer() {
      this.selectedSMSCustomer = {
        CustomerCNUM: "",
        BirchCustomerID: null,
      };
      this.isLinkSMSCustomer = false;
    },
    async linkSMSCustomer() {
      this.isLinkSMSCustomer = true;
      let payload = {
        customerId: Number(this.$route.params.id),
        smsCustomerId: this.selectedSMSCustomer.CustomerCNUM,
        birchCustomerId: this.selectedSMSCustomer.BirchCustomerID,
      };
      try {
        let response = await telematicsService.linkSMSCustomer(payload);
        if (response.isSuccess) {
          this.$toast.success(response.systemMessage);
          if (this.companyIdDropdown == this.$route.params.id) {
            this.$store.dispatch(
              "setSMSCustomerLinkingId",
              this.selectedSMSCustomer.CustomerCNUM,
            );
            this.$store.dispatch(
              "setSMSBirchLinkingId",
              this.selectedSMSCustomer.BirchCustomerID,
            );
          }
          EventBus.$emit("updateSMSCustomer", true);
          this.getCustomer();
        } else {
          this.$toast.error(response.systemMessage);
        }
        this.isLinkSMSCustomer = false;
      } catch (err) {
        this.isLinkSMSCustomer = false;
        console.log(err);
      }
    },
  },
};
